// extracted by mini-css-extract-plugin
export default {"feature":"hotelFeature-module__feature__5iqtF","featureMobile":"hotelFeature-module__featureMobile__CJmlD","iconWrapper":"hotelFeature-module__iconWrapper__2ga5f"};